import CybsButton from '@cybs-ui/components/lib/button';
import Link from '@visa/vds/link';
import React from 'react';
import { connect } from 'react-redux';


class ViewOnGitHubLink extends React.Component
{

   render()
   {
       return(
        <Link href={this.props.sampleCodeUrl} rel="noopener" target="_blank">
        <CybsButton 
          colorScheme="secondary"
          dataTest="github-view"
          i18n={{label: 'View on Github'}}
          disabled={this.props.sampleCodeError == undefined || this.props.sampleCodeError != 'No Error'}
        />
        </Link>
       );

    }
}
function mapStateToProps(state){
  
    return{      
        sampleCodeError: state.examplesReducer.sampleCodeError,
        sampleCodeUrl: state.examplesReducer.sampleCodeUrl,
        
    };
   
}

export default connect(mapStateToProps)(ViewOnGitHubLink);